import type { INumberRange } from "app/UtilitiesAndConstants/types/range";
import type { IWebsiteType } from "pro-features/components/filtersPanel/src/WebsiteTypeFilter";
import type { IOrderBy } from "app/components/React/Table/Utils/sort";

interface IRawDataRecord {
    BounceRate: number;
    DesktopMobileShare: Array<number>;
    PagesPerVisit: number;
    MoMChange: number;
    AvgVisitDuration: number;
    HasAdsense: boolean;
    UniqueUsers: number;
    LastMonthUniqueUsers: number;
    PeriodChange: number;
    CategoryRank: number;
    Domain: string;
    Share: number;
    Rank: number;
    Favicon: string;
    AvgMonthVisits: number;
}

type IRawDataRecords = Array<IRawDataRecord>;

export interface IRawData {
    TotalCount: number;
    Data: IRawDataRecords;
}

interface IRange {
    monthlyVisits: INumberRange;
    uniqueUsers: INumberRange;
}

export interface ITraffic extends IRange {
    isUniqueToggle: boolean;
}
export type ISortableColumns = "TotalShare" | "Change";
export const PRE_DEFINED_PERIOD_CHANGE: INumberRange = { from: 0.1, to: 1 };
const ALL_RANGE_PERIOD_CHANGE: INumberRange = { from: 0, to: 1 };

export interface IFilters {
    websiteType: IWebsiteType;
    traffic: ITraffic;
    orderBy: IOrderBy<ISortableColumns>;
    page: number;
}
